export const login = (userInfo) => ({
  type: "LOGIN",
  payload: userInfo,
});

export const signUp = (userInfo) => ({
  type: "REGISTER",
  payload: userInfo,
});

export const logout = () => ({
  type: "LOGOUT",
  payload: {},
});